// @flow
import { MUST_TRY_EXPERIENCES } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_MUST_TRY_EXPERIENCES } from 'Utils/request/requestDictionary';
import { addTranslationKeys } from 'Src/i18n';

export const productMustTryExperiencesResolver = {
  name: MUST_TRY_EXPERIENCES,
  props(appContext: AppContext) {
    return {
      isFrench: appContext.locale.startsWith('fr'),
    };
  },
  resolve(
    appContext: AppContext,
    props: *,
    pageContext: PageContext,
    location: RouterLocation<UrlParams, {}>,
  ) {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const productArgs = buildProductArgs(productId, urlParams);
    const query = `query {
      config {
        common { next previous scrollBackward scrollForward }
      }
      resort(resortId: "${productId}") {
        resortId
        comfort
        name
        type
      }
      mustTryExperiences(${productArgs}) {
        id
        title
        description
        image
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_PRODUCT_MUST_TRY_EXPERIENCES,
        strictErrors: false,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      })
      .catch(() => ({ mustTryExperiences: [] }));
  },
};
